import React, {FC} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {rgba} from "polished";

import {fadeInAnimation} from "@pg-design/helpers-css";
import {navigationHeight} from "@pg-rp/navigation";

import {isBrowser} from "../app/read_rp_environment_variables";
import {useHeightObserver} from "../hooks/use_height_observer";
interface IDesktopBlend {
    children?: React.ReactNode;
    pageHeight?: string;
    isActive: boolean;
    top?: string;
    heightDecrease?: string;
    isFullScreen?: boolean;
    isViewportWidth?: boolean;
    className?: string;
}

export const DesktopBlend: FC<IDesktopBlend> = (props) => {
    const {pageHeight, ...restProps} = props;
    const {height: pageHeightLocalState, ref} = useHeightObserver({
        isActive: !props.isFullScreen && props.isActive,
        initialHeight: 0
    });

    if (isBrowser && !ref.current) {
        ref.current = document.body;
    }

    return (
        <DesktopBlendStyled {...restProps} pageHeight={pageHeightLocalState ? pageHeightLocalState + "px" : (pageHeight ?? "100vh")}>
            {props.children}
        </DesktopBlendStyled>
    );
};

type IDesktopBlendStyledProps = Pick<IDesktopBlend, "isActive" | "pageHeight" | "top" | "heightDecrease" | "isFullScreen" | "isViewportWidth">;

const DesktopBlendStyled = styled.div<IDesktopBlendStyledProps>`
    display: none;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        display: ${(props) => (props.isActive ? "block" : "none")};
        position: absolute;
        z-index: 1000;
        left: ${(props) => (props.isViewportWidth ? "50%" : "0")};
        width: ${(props) => (props.isViewportWidth ? "100vw" : "100%")};
        transform: ${(props) => (props.isViewportWidth ? "translateX(-50%)" : "none")};
        background-color: ${(props) => rgba(props.theme.colors.secondary, 0.75)};
        top: calc(${(props) => (props.top ? props.top : "0")} + ${`${navigationHeight}px`}); // offset for navigation height
        height: calc(${(props) => props.pageHeight} - ${(props) => (props.heightDecrease ? props.heightDecrease : `${navigationHeight}px`)});
        ${fadeInAnimation("0.2s")};

        ${(props) =>
            props.isFullScreen &&
            css`
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                transform: none;
            `}
    }
`;
import React, {FC} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {rgba} from "polished";

import {fadeInAnimation} from "@pg-design/helpers-css";
import {navigationHeight} from "@pg-rp/navigation";

import {isBrowser} from "../app/read_rp_environment_variables";
import {useHeightObserver} from "../hooks/use_height_observer";
interface IDesktopBlend {
    children?: React.ReactNode;
    pageHeight?: string;
    isActive: boolean;
    top?: string;
    heightDecrease?: string;
    isFullScreen?: boolean;
    isViewportWidth?: boolean;
    className?: string;
}

export const DesktopBlend: FC<IDesktopBlend> = (props) => {
    const {pageHeight, ...restProps} = props;
    const {height: pageHeightLocalState, ref} = useHeightObserver({
        isActive: !props.isFullScreen && props.isActive,
        initialHeight: 0
    });

    if (isBrowser && !ref.current) {
        ref.current = document.body;
    }

    return (
        <DesktopBlendStyled {...restProps} pageHeight={pageHeightLocalState ? pageHeightLocalState + "px" : (pageHeight ?? "100vh")}>
            {props.children}
        </DesktopBlendStyled>
    );
};

type IDesktopBlendStyledProps = Pick<IDesktopBlend, "isActive" | "pageHeight" | "top" | "heightDecrease" | "isFullScreen" | "isViewportWidth">;

const DesktopBlendStyled = styled.div<IDesktopBlendStyledProps>`
    display: none;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        display: ${(props) => (props.isActive ? "block" : "none")};
        position: absolute;
        z-index: 1000;
        left: ${(props) => (props.isViewportWidth ? "50%" : "0")};
        width: ${(props) => (props.isViewportWidth ? "100vw" : "100%")};
        transform: ${(props) => (props.isViewportWidth ? "translateX(-50%)" : "none")};
        background-color: ${(props) => rgba(props.theme.colors.secondary, 0.75)};
        top: calc(${(props) => (props.top ? props.top : "0")} + ${`${navigationHeight}px`}); // offset for navigation height
        height: calc(${(props) => props.pageHeight} - ${(props) => (props.heightDecrease ? props.heightDecrease : `${navigationHeight}px`)});
        ${fadeInAnimation("0.2s")};

        ${(props) =>
            props.isFullScreen &&
            css`
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                transform: none;
            `}
    }
`;
